export enum CompanyActions {
  EDIT_COMPANY = 'edit_company',
  SEND_APP_LINKS = 'send_app_links',
  SEND_SUPPORT = 'send_support',
  SET_COMPANY_SETTING = 'set_company_settings',
}